import { ManagementModal } from "app/pages/sales-intelligence/common-components/modals/ManagementModal/ManagementModal";
import { StyledDeleteModalHeader, CUSTOM_DELETE_STYLES } from "../../../styles/modal";
import { MANAGEMENT_CANCEL_TEXT } from "../../../../translations/managementKeys";
import {
    SL_LIST_MANAGEMENT_DELETE_MODAL_BTN_CONFIRM,
    SL_LIST_MANAGEMENT_DELETE_MODAL_TEXT,
    SL_LIST_MANAGEMENT_DELETE_MODAL_TITLE,
} from "../../../../translations/modals";
import type { ModalProps } from "./types";
import { translate } from "app/filters/i18nFilter";

export const DeleteModal = ({ isOpen, onConfirm, onClose }: ModalProps) => {
    return (
        <ManagementModal
            customStyles={CUSTOM_DELETE_STYLES}
            confirmBtnText={SL_LIST_MANAGEMENT_DELETE_MODAL_BTN_CONFIRM}
            title={
                <StyledDeleteModalHeader>{translate(SL_LIST_MANAGEMENT_DELETE_MODAL_TITLE)}</StyledDeleteModalHeader>
            }
            details={translate(SL_LIST_MANAGEMENT_DELETE_MODAL_TEXT)}
            isOpen={isOpen}
            onConfirm={onConfirm}
            onClose={onClose}
            cancelBtnText={translate(MANAGEMENT_CANCEL_TEXT)}
            confirmBtnType="warning"
            cancelBtnType="flatDark"
        />
    );
};
